module.exports = __webpack_public_path__ + "15fa0e4d01bfebf9c4e66b051e7b95fc.png";